/* src/app/user/user.component.css */
hr {
  width: 100%;
  margin: 2px 3px 5px 3px;
  background: #333333;
}
.setting_headline {
  width: 90%;
  background-color: #dcdee1;
  text-decoration: underline black;
  border-radius: 0.3rem;
  padding: 5px 10px 0px 5px;
  text-align: left;
  font-size: 1.5rem;
  margin-left: 5%;
}
.setting_group {
  width: 90%;
  background-color: #e9ecef;
  border-radius: 0.3rem;
  padding: 5px 10px 0px 5px;
  margin-left: 5%;
}
.setting {
  font-size: 1.5rem;
  font-weight: 300;
}
.setting ui-switch {
  float: right;
  position: relative;
  top: -2px;
}
.setting .arrow {
}
i {
  float: right;
  margin: 4px 15px 0px 0px;
  border: solid black;
  border-width: 0 8px 8px 0;
  display: inline-block;
  padding: 6px;
}
.right {
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
}
/*# sourceMappingURL=user.component-XS24ACJM.css.map */
